module.exports = __webpack_public_path__ + "img/palm2_9.f4345fa6.png";